import { render } from "./HistoryItem.vue?vue&type=template&id=24b08922"
import script from "./HistoryItem.vue?vue&type=script&lang=js"
export * from "./HistoryItem.vue?vue&type=script&lang=js"

import "./HistoryItem.vue?vue&type=style&index=0&id=24b08922&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__